(() => {
  const BUTTON_SELECTOR = '.utils-viewtoggle-button[data-collection-view]';
  const OUTER_SELECTOR = '[data-productgrid-outer]';
  const GRID_CLASS = 'productgrid-gridview';
  const LIST_CLASS = 'productgrid-listview';

  function getOuter(button) {
    return button.closest(OUTER_SELECTOR) || document.querySelector(OUTER_SELECTOR);
  }

  function setActive(button, view) {
    const container = button.closest('.utils-viewtoggle') || document;
    container.querySelectorAll(BUTTON_SELECTOR).forEach(btn => {
      const isActive = btn.getAttribute('data-collection-view') === view;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function setOuterView(outer, view) {
    if (!outer) return;
    outer.classList.remove(GRID_CLASS, LIST_CLASS);
    const className = view.replace('-', '');
    outer.classList.add(`productgrid-${className}`);
  }

  function updateUrl(view) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('grid_list', view);
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      // no-op
    }
  }

  function handleClick(event) {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const view = button.getAttribute('data-collection-view');
    if (!view) return;

    const outer = getOuter(button);
    setOuterView(outer, view);
    setActive(button, view);
    updateUrl(view);

    // List vs grid changes image box geometry; re-scan lazy rimg + clear eager-image markers
    const gridItems = outer?.querySelector('[data-productgrid-items]');
    if (gridItems) {
      if (window.rimg && typeof window.rimg.watch === 'function') {
        try {
          window.rimg.watch(gridItems);
        } catch (_) {}
      }
      gridItems.dispatchEvent(
        new CustomEvent('theme:rimg:watch', { bubbles: true, cancelable: true }),
      );
    }
  }

  document.addEventListener('click', handleClick, true);
})();
